



















































import Vue from 'vue';
import {HTTP} from '../utils/httpCommonUtil';
import VueSimpleSpinner from 'vue-simple-spinner'

export default Vue.component('filter-component', {
  name: 'FilterComponent',
  components: {
    VueSimpleSpinner
  },
  props: {
    filterTypes: { type: Object, required: true },
    titleText: { type: String, required: true },
    buttonText: { type: String, required: true },
    placeholder: { type: String, default: 'Search...' },
    justifyTabs: {type: Boolean, default: true },
    alignDropdownLeft: {type: Boolean, default: false },
    defaultFilters: { type: Array, default: () => [] },
    showBadge: { type: Boolean, default: false}
  },
  data () {
    return {
      filtersSelected: [] as any[],
      showFiltersDropdown: false,
      filterSearchInput: '',
      ourFilterTypes: [] as any[],
      loadingFilterSearchResults: false,
      searchCountResults: 0,
      searchResults: [] as any[],
      moreSearchResultsAvailable: false,
      filterValues: {} as any,
      processingFilterSearch: false,
      disableSearch: false
    };
  },
  watch: {
    filterTypes () {
      this.loadFilterTypes();
    },
    filterValues: {
      deep: true,
      handler: function (val, oldVal) {
        let filtersSelected = [];
        for (const key in val) {
          if (val.hasOwnProperty(key)) {
            filtersSelected.push(...val[key]);
          }
        }
        this.filtersSelected = filtersSelected;
        this.$emit('filter-changed', this.filtersSelected);
      }
    },
    defaultFilters() {
      this.setSelectedFilters ();
    }
  },
  created () {
    this.loadFilterTypes();
    this.setSelectedFilters();
  },
  methods: {
    loadFilterTypes () {
      const toReturn = [] as any[];
      const newFilterValues = {} as any;
      for (const key in this.filterTypes) {
        if (this.filterTypes.hasOwnProperty(key)) {
          toReturn.push(this.filterTypes[key]);
          newFilterValues[key] = [];
        }
      }
      this.filterValues = newFilterValues;
      this.ourFilterTypes = toReturn;
      this.updateSelectedFilter(this.ourFilterTypes[0]);
    },
    setSelectedFilters () {
      this.clearAllFilters();
      this.defaultFilters.forEach((filter: any) => {
        this.filterValues[filter.filterTypeId].push(filter);
      })
    },
    showFilters () {
      this.showFiltersDropdown = !this.showFiltersDropdown;
      setTimeout(() => {
        (this.$refs.searchFilterInput as any).focus();
        (this.$refs.searchFilterInput as any).select();
      }, 300);
    },
    clearAllFilters () {
      for (const key in this.filterValues) {
        if (this.filterValues.hasOwnProperty(key)) {
          this.filterValues[key] = [];
        }
      }
    },
    updateSelectedFilter (filterType: any) {
      (this.ourFilterTypes as any[]).forEach( (shiftFilterInstance) => {
        shiftFilterInstance.isSelected = shiftFilterInstance.id === filterType.id;
        this.filterSearchInput = '';
        if (filterType.searchEnum && filterType.searchEnum.length) {
          this.searchResults = filterType.searchEnum;
          this.disableSearch = true;
        } else {
          this.searchResults = [];
          this.disableSearch = false;
        }
        this.searchCountResults = 0;
        setTimeout(() => {
          (this.$refs.searchFilterInput as any).focus();
          (this.$refs.searchFilterInput as any).select();
        },300);
      })
    },
    async filterSearch () {
      if (this.processingFilterSearch) { return; }
      if (!this.filterSearchInput) {
        return;
      }
      this.processingFilterSearch = true;
      setTimeout(async () => {
        let showLoadingSpinnerTimeout = setTimeout(() => {
          this.loadingFilterSearchResults = true;
        }, 0);
        let currentSearchInput = this.filterSearchInput;
        let currentlySelectedShiftFilter = (this.ourFilterTypes as any[]).filter((filterType: any) => { return filterType.isSelected; } );
        if (!currentlySelectedShiftFilter[0]) { throw new Error("Error searching filter types."); }
        try {
          const response = await HTTP.get(currentlySelectedShiftFilter[0].searchAPI + this.filterSearchInput + '&forceResults=false');
          this.processingFilterSearch = false;
          this.searchCountResults = response.data.data.count;
          this.searchResults = currentlySelectedShiftFilter[0].conditionResponseData(response.data.data.results);
          clearTimeout(showLoadingSpinnerTimeout);
          if (this.filterSearchInput !== currentSearchInput) {
            await this.filterSearch();
          }
        } catch (err) {
          clearTimeout(showLoadingSpinnerTimeout);
          this.processingFilterSearch = false;
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Getting Results',
            text: 'Searching filters failed.',
          });
        }
        this.loadingFilterSearchResults = false;
      }, 100);
    },
    selectFilter (filter: any) {
      const toCheck = this.filterValues[filter.filterTypeId];
      const existingFilters = this.findDuplicateFilters(filter.id, toCheck);
      if (!existingFilters.length) {
        toCheck.push(filter);
        this.filterValues[filter.filterTypeId] = toCheck;
      }
    },
    findDuplicateFilters (filterId: number, filterArray: any[]): any[] {
      return filterArray.filter((item: any) => item.id === filterId);
    },
    unselectFilter (filter: any) {
      const key = filter.filterTypeId;
      this.filterValues[key] = this.filterValues[key].filter((item: any) => filter.name !== item.name);
    },
    enterPressed() {
      if (!this.loadingFilterSearchResults && this.searchResults.length === 1) {
        this.selectFilter(this.searchResults[0]);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/FilterComponent.vue